import { ActionType } from '@/types/actionType';
import { LOG_OUT } from '../auth/actionTypes';
import { FETCH_ROLES } from './actionTypes';

const initState = {
	list: [],
	companylist: [],
};

const reducer = (state = initState, action) => {
	switch (action.type) {
		case FETCH_ROLES:
			return {
				...state,
				list: action.payload,
			};
		case ActionType.COMPANY_FETCH_ROLES:
			return {
				...state,
				companylist: action.payload,
			};
		case LOG_OUT:
			return initState;
		default:
			return state;
	}
};

export default reducer;
